import { EntityViewVariant, ViewVariant } from "@/common/ts/layout";

import { ViewLayout, ViewLayoutProps } from "./ViewLayout";

interface Props extends ViewLayoutProps {}

export default function ListViewLayout({ displayProps, ...otherProps }: Props) {
  return (
    <ViewLayout
      displayProps={{
        breadcrumbs: true,
        viewVariant: ViewVariant.Page,
        entityViewVariant: EntityViewVariant.List,
        ...displayProps,
      }}
      {...otherProps}
    />
  );
}
